export function sectionSpacing(value?: string): string {
  switch (value) {
    // 44px between blocks on desktop, 40 on tablet and mobile.
    case "group_start_44":
      return "pt-10 pb-5 md:pt-10 md:pb-5 lg:pt-20 lg:pb-[22px]";
    case "group_mid_44":
      return "py-5 md:py-5 lg:py-[22px]";
    case "group_end_44":
      return "pt-5 pb-10 md:pt-5 md:pb-10 lg:pt-[22px] lg:pb-20";
    // 64px between blocks on desktop, 36 on tablet and mobile.
    case "group_start_64":
      return "pt-10 pb-[18px] md:pt-10 md:pb-[18px] lg:pt-20 lg:pb-8";
    case "group_mid_64":
      return "py-[18px] md:py-[18px] lg:py-8";
    case "group_end_64":
      return "pt-[18px] pb-10 md:pt-[18px] md:pb-10 lg:pt-8 lg:pb-20";
    case "group_start_120":
      return "pt-10 pb-[22px] md:pt-10 md:pb-[22px] lg:pt-20 lg:pb-15";
    case "group_mid_120":
      return "py-[22px] md:py-[22px] lg:py-15";
    case "group_end_120":
      return "pt-[22px] pb-10 md:pt-[22px] md:pb-10 lg:pt-15 lg:pb-20";
    // Sits flush under the block above it (1:7104, directly under the hero).
    case "flush_top":
      return "pt-0 pb-10 md:pb-10 lg:pb-20";
    default:
      return "py-10 md:py-10 lg:py-20";
  }
}
